import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92f1781a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-main" }
const _hoisted_2 = { class: "form-label" }
const _hoisted_3 = { class: "radio-card-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "radio-card-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "填写设备信息", -1))
const _hoisted_7 = { class: "radio-group-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("设备品牌 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_9 = {
  key: 0,
  class: "icon-arrow-right-svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("产品类型 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("设备序列号 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_13 = {
  key: 2,
  class: "icon-arrow-right-svg"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("您名下的机型 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_15 = { class: "with-tips" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("补贴领取是否满足要求 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_17 = { class: "radio-group-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips text-gray" }, "注：指设备未领取国家农机补贴或已领取满两年", -1))
const _hoisted_19 = { class: "with-tips" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("部件、功能是否完好 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_21 = { class: "radio-group-wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "选择提机的服务站", -1))
const _hoisted_23 = { class: "radio-group-container" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("服务网点 "),
  /*#__PURE__*/_createElementVNode("i", { class: "require-icon" })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_26 = { class: "popup-select-container" }
const _hoisted_27 = { class: "popup-top xag-flex-lr" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择设备品牌", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-selected-svg" }, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon replace-v3-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "record-no-data-tips" }, "暂无可选品牌")
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "popup-select-container" }
const _hoisted_36 = { class: "popup-top xag-flex-lr" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择设备", -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "info" }
const _hoisted_40 = { class: "name xag-ellipsis" }
const _hoisted_41 = { class: "sn xag-ellipsis" }
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon replace-v3-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "record-no-data-tips" }, "暂无可申请的设备")
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 0,
  class: "popup-bottom form-footer device-replace-button-wrap"
}
const _hoisted_47 = { class: "popup-select-container" }
const _hoisted_48 = { class: "popup-top xag-flex-lr" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择产品类型", -1))
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-selected-svg" }, null, -1))
const _hoisted_53 = { class: "popup-bottom form-footer device-replace-button-wrap" }
const _hoisted_54 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, Ref, reactive, computed, ComputedRef, watch } from 'vue'
import AppHeader from '@/components/Header.vue'
import { Toast, RadioGroup, Radio, Field, Button, Dialog, Popup } from 'vant'
import { useRouter, Router } from 'vue-router'
import getRoute from '@/compositions/route'
import { NetworkpointItem } from '@/types/fault'
import {
  getUserDeviceList,
  getBrandList,
  editDeviceApply,
  checkProductSn,
} from '@/apis/device-replace-v3'
import {
  UserDeviceItem,
  BrandItem,
  BrandListSelectItem,
  ModelTypeSelectItem,
} from '@/types/device-replace-v3'
import {
  deviceTypeOptions,
  modelTypeOptions,
  parameterCacheKey,
  userDeviceCacheKey,
  brandCacheKey,
} from './definition'
import { showToastLoading, showToastSuccess, clearToast } from '@/utils/tools'
import { copy } from '@/utils/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-form',
  setup(__props) {

const $router: Router = useRouter()
let onLeftClick = function () {
  $router.back()
}

const { query } = getRoute()
const recordGuidQuery = (query.value.record as string) || ''
const appHeaderText: ComputedRef<string> = computed(() => {
  return recordGuidQuery ? '修改设备信息' : '添加申请'
})
const buttonText: ComputedRef<string> = computed(() => {
  return recordGuidQuery ? '确认修改' : '下一步'
})
const action: ComputedRef<string> = computed(() => {
  return recordGuidQuery ? 'edit' : 'add'
})

const pHeightMax: ComputedRef<number> = computed(() => {
  const height = window.innerHeight
  return height * 0.9
})
const VanDialog = Dialog.Component
const checkColor = '#00B359'
function setDataCache() {
  // 设置parameter数据缓存
  sessionStorage.setItem(
    parameterCacheKey,
    JSON.stringify({
      parameter: { ...parameter },
    })
  )
  // 设置brandList缓存
  sessionStorage.setItem(
    brandCacheKey,
    JSON.stringify({
      brandList: brandList.value,
    })
  )
  // 设备userDevice缓存
  sessionStorage.setItem(
    userDeviceCacheKey,
    JSON.stringify({
      userDeviceList: userDeviceList.value,
    })
  )
}
let parameter = reactive({
  radio_isXAG: '1',
  radio_substitution: '0',
  radio_complete: '1',
  radio_undamaged: '1',
  radio_match: '',
  radio_completeAndUndamaged: '',
  model: '',
  model_type: '1', // 产品类型 1-无人机 2-自驾仪
  model_type_text: '无人机',
  brand: '1',
  brand_name: '极飞XAG',
  product_sn: '',
  product_name: '',
  code: '',
  client_guid: '',
  client_name: '',
})
watch(
  () => parameter,
  (newVal, oldVal) => {
    canComfirm.value = verifyParameter(false) || false
  },
  {
    deep: true,
  }
)
const isXAGBrand: ComputedRef<boolean> = computed(() => {
  return parameter.radio_isXAG === '1'
})

// radio切换前的产品信息数据
let temPreInfo = {
  brand: '',
  brand_name: '',
  product_sn: '',
  product_name: '',
  model: '',
  code: '',
  model_type: '2',
  model_type_text: '自驾仪',
}
function onRadioIsXAGChange(value: string) {
  let tempData = copy(temPreInfo)
  for (let key in temPreInfo) {
    temPreInfo[key] = parameter[key]
  }
  // paramter 使用上一份切换数据
  for (let key in tempData) {
    parameter[key] = tempData[key]
  }
  if (value === '1') {
    parameter.brand = '1'
    parameter.brand_name = brandList.value['1'] || '极飞XAG'
    parameter.model_type = '1'
    parameter.model_type_text = '无人机'
  }
}

const brandSelectShow = ref(false)
const brandListLoading = ref(false)
const brandList: Ref<BrandItem> = ref({})
const brandListToSelect: ComputedRef<Array<BrandListSelectItem>> = computed(() => {
  let list = [] as BrandListSelectItem[]
  Object.keys(brandList.value).forEach((key: string) => {
    if (key !== '1') {
      list.push({
        id: key,
        brand: brandList.value[key],
      })
    }
  })
  return list
})
async function fetchBrandList() {
  brandListLoading.value = true
  let data
  let cacheBrandJson = sessionStorage.getItem(brandCacheKey)
  if (cacheBrandJson) {
    const cacheBrandData = JSON.parse(cacheBrandJson)
    data = cacheBrandData.brandList
    sessionStorage.removeItem(brandCacheKey)
  } else {
    try {
      data = await getBrandList()
      console.log('brandList', data)
    } catch (error) {
      console.log('error', error)
    }
  }
  brandList.value = data || {}
  brandListLoading.value = false
}
function showBrandSelect() {
  if (isXAGBrand.value) return
  brandSelectShow.value = true
}
function onBrandSelect(brand: BrandListSelectItem) {
  parameter.brand = brand.id
  parameter.brand_name = brand.brand
  brandSelectShow.value = false
}

const modelTypeSelectShow = ref(false)
const modelTypeSelectTemp = ref('')
function showModelTypeSelect() {
  if (isXAGBrand.value) return
  modelTypeSelectTemp.value = parameter.model_type || '1'
  modelTypeSelectShow.value = true
}
function onModelTypeSelect(type: ModelTypeSelectItem) {
  modelTypeSelectTemp.value = type.value
}
function confirmModelTypeSelect() {
  let typeV = modelTypeSelectTemp.value
  let findItem =
    modelTypeOptions.find((item) => {
      return item.value === typeV
    }) || undefined
  if (!findItem) return
  parameter.model_type = findItem.value
  parameter.model_type_text = findItem.label
  modelTypeSelectShow.value = false
}

const userDeviceShow = ref(false)
const userDeviceLoading = ref(false)
const userDeviceList = ref([])
const userDeviceRadio = ref('')
const userDeviceToSelect: ComputedRef<Array<UserDeviceItem>> = computed(() => {
  let list = []
  list = userDeviceList.value.filter((item) => {
    return !item.is_apply
  })
  return list
})
async function fetchUserDeviceList() {
  userDeviceLoading.value = true
  let data
  let cacheUserDeviceJson = sessionStorage.getItem(userDeviceCacheKey)
  if (cacheUserDeviceJson) {
    const cacheUserDeviceData = JSON.parse(cacheUserDeviceJson)
    data = cacheUserDeviceData.userDeviceList
    sessionStorage.removeItem(userDeviceCacheKey)
  } else {
    try {
      data = await getUserDeviceList()
      console.log('data', data)
    } catch (error) {}
  }
  userDeviceList.value = data || []
  userDeviceLoading.value = false
}
function showUserDeviceSelect() {
  if (!isXAGBrand.value) return
  userDeviceRadio.value = parameter.product_sn
  userDeviceShow.value = true
}
function comfirmUserDeviceSelect() {
  let sn = userDeviceRadio.value
  let findItem =
    userDeviceList.value.find((item) => {
      return item.serial_number === sn
    }) || undefined
  if (!findItem) return
  if (findItem && findItem.is_apply) {
    // 已申请
    return Dialog({
      message: '此设备已申请参与过此项活动，无法再次申请',
      confirmButtonText: '我知道了',
      className: 'device-replace-v3-dialog',
      width: 304,
    })
  }
  if (findItem && findItem.is_subsidy) {
    // 已申请补贴
    return Dialog({
      message:
        '系统检测当前设备已申报国家农机补贴，不符合参与活动规则。若未领取补贴，请联系在线客服或拨打客服热线 ：<span style="color: #569AFF;"> 400-780-3131 </span>',
      confirmButtonText: '我知道了',
      className: 'device-replace-v3-dialog',
      allowHtml: true,
      width: 304,
    })
  }
  parameter.product_sn = findItem.serial_number
  parameter.model = findItem.model || ''
  parameter.code = findItem.code || ''
  parameter.product_name = findItem.name || ''
  userDeviceShow.value = false
}

function onRdioMatchChange(value: string) {
  if (value === '0') {
    Dialog({
      message: '设备需未领取国家农机补贴或已领满两年才可参与活动',
      confirmButtonText: '我知道了',
      className: 'device-replace-v3-dialog',
      width: 304,
    })
    parameter.radio_match = ''
  }
}
const completeAndUndamagedDialogShow = ref(false)
function onRdioCompleteAndUndamagedChange(value: string) {
  if (value === '0') {
    completeAndUndamagedDialogShow.value = true
    parameter.radio_completeAndUndamaged = ''
  }
}

let toSelectWarehouse = function () {
  setDataCache()
  $router.push({ name: 'device-replace-v3-apply-warehouse-point' })
}
function verifyParameter(showToast = true): boolean {
  let message = ''
  if (!parameter.radio_match) {
    message = '请选择补贴领取是否满足要求'
  } else if (!parameter.radio_completeAndUndamaged) {
    message = '请选择部件、功能是否完好'
  } else if (!parameter.client_name) {
    message = '请选择销售网点'
  }
  if (!parameter.product_sn) {
    message = `请${isXAGBrand.value ? '选择' : '填写'}设备序列号`
  }
  if (parameter.radio_isXAG === '0') {
    if (!parameter.model) {
      message = '请填写机型'
    }
    if (!parameter.model_type) {
      message = '请选择产品类型'
    }
    if (!parameter.brand) {
      message = '请选择设备品牌'
    }
  }
  if (message) {
    showToast && Toast(message)
    return false
  }
  return true
}
const canComfirm = ref(false)
async function sumbit() {
  console.log('提交的参数', parameter)
  if (!verifyParameter()) {
    return
  }
  showToastLoading({
    message: '验证设备序列号...',
  })
  try {
    await checkProductSn({ product_sn: parameter.product_sn, order_guid: recordGuidQuery })
    clearToast()
    if (action.value === 'add') {
      setDataCache()
      $router.push({
        name: 'device-replace-v3-apply-choose-device',
        query: { key: parameterCacheKey },
      })
    } else if (action.value === 'edit') {
      showToastLoading({
        message: '修改信息',
      })
      const params = {
        guid: recordGuidQuery, //申请单guid
        model: parameter.model, //型号
        product_sn: parameter.product_sn, //序列号
        code: parameter.code, //物料编码 可传空
        product_name: parameter.product_name, //产品名称 可传空
        brand: Number(parameter.brand), //品牌
        model_type: Number(parameter.model_type), // 产品类型
      }
      // 极飞品牌 model_type不传
      if (params.brand === 1) {
        delete params.model_type
      }
      try {
        await editDeviceApply(params)
        clearToast()
        showToastSuccess('信息修改成功')
        setTimeout(() => {
          clearToast()
          $router.replace({
            name: 'device-replace-v3-record-detail',
            query: { guid: recordGuidQuery },
          })
        }, 1000)
      } catch (error) {
        clearToast()
        console.log('信息修改失败', error)
        let message = error && error.message ? error.message : '信息修改失败'
        Dialog({
          message,
          confirmButtonText: '我知道了',
          className: 'device-replace-v3-dialog',
          width: 304,
        })
      }
    }
  } catch (error) {
    clearToast()
    return Dialog({
      message: error?.message || '序列号无法申请',
      confirmButtonText: '我知道了',
      className: 'device-replace-v3-dialog',
      width: 304,
    })
  }
}

const popupShow: ComputedRef<boolean> = computed(() => {
  return brandSelectShow.value || userDeviceShow.value || modelTypeSelectShow.value
})
function checkProtocol() {
  setDataCache()
  $router.push({ name: 'device-replace-v3-self-check-device-list' })
}

function initPageData() {
  fetchUserDeviceList()
  fetchBrandList()
  // 获取缓存数据
  let cacheParameterJson = sessionStorage.getItem(parameterCacheKey)
  if (cacheParameterJson) {
    const cacheData = JSON.parse(cacheParameterJson)
    for (let key in parameter) {
      parameter[key] = cacheData.parameter[key]
    }
    console.log('缓存数据', cacheData)
    sessionStorage.removeItem(parameterCacheKey)
  }
  let cachePointJSON = sessionStorage.getItem('DeviceReplacePointerData')
  let cachePoint: NetworkpointItem = cachePointJSON ? JSON.parse(cachePointJSON) : null
  if (cachePoint) {
    parameter.client_guid = cachePoint.guid
    parameter.client_name = cachePoint.name
    const area = cachePoint.area
    if (area.indexOf('湖南省') !== -1) {
      setTimeout(() => {
        Dialog({
          message:
            '非湖南企业所销售的农业无人机在湖南省暂无法办理农机购置补贴，建议您可联系当地极飞授权经销商购买产品，若在本平台购买可能导致无法办理农机购置补贴，请确认是否购买。',
          confirmButtonText: '我知道了',
          className: 'device-replace-v3-dialog',
          width: 304,
        })
      }, 300)
    }
    sessionStorage.removeItem('DeviceReplacePointerData')
  }
}
initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: _unref(appHeaderText),
      isReturnLeftEvent: "",
      onLeftClick: _unref(onLeftClick)
    }, null, 8, ["title", "onLeftClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(isXAGBrand) ? '选择机型' : '选择品牌'), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(RadioGroup), {
          modelValue: _unref(parameter).radio_isXAG,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(parameter).radio_isXAG) = $event)),
          direction: "horizontal",
          "checked-color": checkColor,
          onChange: onRadioIsXAGChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceTypeOptions), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: _normalizeClass(["radio-card xag-flex-lr", _unref(parameter).radio_isXAG === item.value ? 'checked' : '']),
                onClick: ($event: any) => (_unref(parameter).radio_isXAG = item.value)
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1),
                _createVNode(_unref(Radio), {
                  name: item.value
                }, null, 8, ["name"])
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", { onClick: showBrandSelect }, [
            _hoisted_8,
            _createElementVNode("div", {
              class: _normalizeClass(["value", _unref(parameter).brand_name ? '' : 'no-value'])
            }, _toDisplayString(_unref(parameter).brand_name || '请选择设备品牌'), 3),
            (!_unref(isXAGBrand))
              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          (!_unref(isXAGBrand))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                onClick: showModelTypeSelect
              }, [
                _hoisted_10,
                _createElementVNode("div", {
                  class: _normalizeClass(["value", _unref(parameter).model_type ? '' : 'no-value'])
                }, _toDisplayString(_unref(parameter).model_type_text || '请选择产品类型'), 3),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", { onClick: showUserDeviceSelect }, [
            _hoisted_12,
            (!_unref(isXAGBrand))
              ? (_openBlock(), _createBlock(_unref(Field), {
                  key: 0,
                  modelValue: _unref(parameter).product_sn,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(parameter).product_sn) = $event)),
                  modelModifiers: { trim: true },
                  name: "model",
                  placeholder: "请填写序列号",
                  "input-align": "right"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["value", _unref(parameter).product_sn ? '' : 'no-value'])
                }, _toDisplayString(_unref(parameter).product_sn || '请选择设备序列号'), 3)),
            (_unref(isXAGBrand))
              ? (_openBlock(), _createElementBlock("i", _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            _hoisted_14,
            (!_unref(isXAGBrand))
              ? (_openBlock(), _createBlock(_unref(Field), {
                  key: 0,
                  modelValue: _unref(parameter).model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(parameter).model) = $event)),
                  modelModifiers: { trim: true },
                  name: "model",
                  placeholder: "请填写机型",
                  "input-align": "right"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["value", _unref(parameter).model ? '' : 'no-value'])
                }, _toDisplayString(_unref(parameter).model || '填写序列号自动获取'), 3))
          ]),
          (_unref(action) === 'add')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(RadioGroup), {
                      modelValue: _unref(parameter).radio_match,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(parameter).radio_match) = $event)),
                      class: "radio-group",
                      "checked-color": checkColor,
                      onChange: onRdioMatchChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Radio), { name: "0" }, {
                          default: _withCtx(() => [
                            _createTextVNode("否")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Radio), { name: "1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("是")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _hoisted_18
                ]),
                _createElementVNode("li", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(RadioGroup), {
                      modelValue: _unref(parameter).radio_completeAndUndamaged,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(parameter).radio_completeAndUndamaged) = $event)),
                      class: "radio-group",
                      "checked-color": checkColor,
                      onChange: onRdioCompleteAndUndamagedChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Radio), { name: "0" }, {
                          default: _withCtx(() => [
                            _createTextVNode("否")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Radio), { name: "1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("是")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", { class: "tips" }, [
                    _createTextVNode(" 注：可点击查看"),
                    _createElementVNode("span", {
                      class: "protocol",
                      onClick: checkProtocol
                    }, "《置换设备检查单》，"),
                    _createTextVNode("进行设备自检 ")
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(action) === 'add')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(toSelectWarehouse) && _unref(toSelectWarehouse)(...args)))
                }, [
                  _hoisted_24,
                  _createElementVNode("div", {
                    class: _normalizeClass(["value", _unref(parameter).client_name ? '' : 'no-value'])
                  }, _toDisplayString(_unref(parameter).client_name || '请选择'), 3),
                  _hoisted_25
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_unref(Popup), {
        show: brandSelectShow.value,
        "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((brandSelectShow).value = $event)),
        "safe-area-inset-bottom": "",
        round: "",
        position: "bottom",
        style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("i", {
                class: "icon-close-svg",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (brandSelectShow.value = false), ["stop"]))
              })
            ]),
            _createElementVNode("div", {
              class: "popup-list",
              style: _normalizeStyle({ maxHeight: `${_unref(pHeightMax)}px` })
            }, [
              (_unref(brandListToSelect).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brandListToSelect), (brand) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: brand.id,
                        class: _normalizeClass(["popup-list-item xag-flex-lr", _unref(parameter).brand === brand.id ? 'selected' : '']),
                        onClick: ($event: any) => (onBrandSelect(brand))
                      }, [
                        _createTextVNode(_toDisplayString(brand.brand) + " ", 1),
                        _hoisted_31
                      ], 10, _hoisted_30))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
            ], 4)
          ])
        ]),
        _: 1
      }, 8, ["show", "style"]),
      _createVNode(_unref(Popup), {
        ref: "popupWrap",
        show: userDeviceShow.value,
        "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((userDeviceShow).value = $event)),
        "safe-area-inset-bottom": "",
        round: "",
        position: "bottom",
        style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("i", {
                class: "icon-close-svg",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (userDeviceShow.value = false), ["stop"]))
              })
            ]),
            _createElementVNode("div", {
              class: "popup-list with-popuo-bottom",
              style: _normalizeStyle({
            maxHeight: `${_unref(pHeightMax)}px`,
            paddingBottom: _unref(userDeviceToSelect).length ? `128px` : `28px`,
          })
            }, [
              (_unref(userDeviceToSelect).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                    _createVNode(_unref(RadioGroup), {
                      modelValue: userDeviceRadio.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userDeviceRadio).value = $event)),
                      "checked-color": checkColor,
                      "icon-size": "24"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userDeviceToSelect), (device) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: device.serial_number,
                            class: "popup-list-item xag-flex-lr"
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, "设备名称： " + _toDisplayString(device.name), 1),
                              _createElementVNode("div", _hoisted_41, "设备序列号： " + _toDisplayString(device.serial_number), 1)
                            ]),
                            _createVNode(_unref(Radio), {
                              name: device.serial_number
                            }, {
                              icon: _withCtx((props) => [
                                _createElementVNode("img", {
                                  class: "img-icon",
                                  src: 
                        props.checked
                          ? '/images/icon_radio_checked.svg'
                          : '/images/icon_radio_unchecked.svg'
                      
                                }, null, 8, _hoisted_42)
                              ]),
                              _: 2
                            }, 1032, ["name"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
            ], 4),
            (_unref(userDeviceToSelect).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button",
                    onClick: comfirmUserDeviceSelect
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确定")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["show", "style"]),
      _createVNode(_unref(Popup), {
        show: modelTypeSelectShow.value,
        "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((modelTypeSelectShow).value = $event)),
        "safe-area-inset-bottom": "",
        round: "",
        position: "bottom",
        style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("i", {
                class: "icon-close-svg",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (modelTypeSelectShow.value = false), ["stop"]))
              })
            ]),
            _createElementVNode("div", {
              class: "popup-list with-popuo-bottom",
              style: _normalizeStyle({
            maxHeight: `${_unref(pHeightMax)}px`,
            paddingBottom: `128px`,
          })
            }, [
              (_unref(modelTypeOptions).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypeOptions), (typeItem) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: typeItem.value,
                        class: _normalizeClass(["popup-list-item xag-flex-lr", modelTypeSelectTemp.value === typeItem.value ? 'selected' : '']),
                        onClick: ($event: any) => (onModelTypeSelect(typeItem))
                      }, [
                        _createTextVNode(_toDisplayString(typeItem.label) + " ", 1),
                        _hoisted_52
                      ], 10, _hoisted_51))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_unref(Button), {
                square: "",
                type: "success",
                class: "xa-vant-button",
                onClick: confirmModelTypeSelect
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["show", "style"]),
      _createVNode(_unref(VanDialog), {
        show: completeAndUndamagedDialogShow.value,
        "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((completeAndUndamagedDialogShow).value = $event)),
        class: "device-replace-v3-dialog",
        width: "304",
        "confirm-button-text": "我知道了",
        "show-cancel-button": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", { class: "van-dialog__message" }, [
            _createTextVNode(" 部件、功能需完好才可参与，具体要求可点击查看"),
            _createElementVNode("span", {
              style: {"color":"#569aff"},
              class: "protocol",
              onClick: checkProtocol
            }, " 《置换设备检查单》"),
            _createTextVNode("，进行自检 ")
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    (!_unref(popupShow))
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createVNode(_unref(Button), {
            square: "",
            type: "success",
            class: _normalizeClass(["xa-vant-button", canComfirm.value ? 'xa-vant-button' : 'xa-vant-button-cancel']),
            onClick: sumbit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_55
  ], 64))
}
}

})